import { useEffect } from "react";
import { isProduction } from "../../utils/checkEnv";
import { getHotjarService } from "./source";

export const useHotjar = () => {
  useEffect(() => {
    const isProd = isProduction();
    if (isProd) {
      getHotjarService();
    }
  }, []);
};
